import React from "react";
import "./GroupLine.css";
import {GroupResponse} from "../logic/APITypes";
import {NameLogo} from "./NameLogo";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";

const GroupLine = ({id, name, apps, admins, member_count}: GroupResponse) => {
  return (
    <Link className="groupLine" to={"/groups/" + id} state={{from: "groups"}}>
      <div className="groupLine__row groupLine__title">
        <NameLogo text={name} id={id} size={48} />
        {name}
      </div>
      <div className="groupLine__column">
        <div className="groupLine__row">
          <span>
            <b>
              <FormattedMessage id="groupLine.memberCount" />
            </b>
            {member_count}
          </span>
          <span>
            <b>
              <FormattedMessage id="groupLine.admins" />
            </b>
            {admins.length === 0 ? "—" : admins.join(", ")}
          </span>
        </div>
        <div className="groupLine__row groupLine__apps">
          {apps.length === 0 ? (
            <i>
              <FormattedMessage id="groupLine.noApps" />
            </i>
          ) : (
            <span>
              <b>
                <FormattedMessage id="groupLine.apps" />
              </b>
              {apps.join(", ")}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};

export {GroupLine};
